import React, { useState } from 'react';

import useSearchStore from '../../_global/js/SearchStore';

import ClearFacetsButton from '../../search-page-resources/jsx/ClearFacetsButton';

export default function SearchFilterContainer({
    sortSelectOptions,
    children,
    hideFacets = false,
    hideSearchBar = false,
}) {
    const [sortIsOpen, setSortIsOpen] = useState(false);
    const [filtersIsOpen, setFiltersIsOpen] = useState(false);

    const searchFacetSelections = useSearchStore(
        (state) => state.searchFacetSelections
    );

    const searchSortingValue = useSearchStore(
        (state) => state.searchSortingValue
    );
    const setSearchSortingValue = useSearchStore(
        (state) => state.setSearchSortingValue
    );

    /**
     * Respond to clicks on the close buttons.
     *
     * @param {Click Event} evt Event that triggered the click
     *
     * @returns void
     */
    const onCloseButtonClick = (evt) => {
        evt.preventDefault();
        setSortIsOpen(false);
        setFiltersIsOpen(false);
    };

    /**
     * Respond to clicks on the open sort menu button.
     *
     * @param {Click Event} evt Event that triggered the click
     *
     * @returns void
     */
    const onSortOpenButtonClick = (evt) => {
        evt.preventDefault();
        setSortIsOpen(true);
    };

    /**
     * Respond to clicks on the open filters menu button.
     *
     * @param {Click Event} evt Event that triggered the click
     *
     * @returns void
     */
    const onFiltersOpenButtonClick = (evt) => {
        evt.preventDefault();
        setFiltersIsOpen(true);
    };

    /**
     * Respond to clicks on the sorting option button(s).
     *
     * @param {Click Event} evt Event that triggered the click
     *
     * @returns void
     */
    const onSelectSortOptionClick = (evt) => {
        const selectedValue =
            evt.currentTarget.getAttribute('data-option-value');

        evt.preventDefault();

        // Update the shared state with the new value
        setSearchSortingValue(selectedValue);

        // Close the sort menu
        setSortIsOpen(false);
    };

    return (
        <div className="content no-wysiwyg">
            <button
                className={`filter-open_overlay ${
                    sortIsOpen || filtersIsOpen ? 'open' : ''
                }`}
                onClick={onCloseButtonClick}
                type="button"
            >
                <span className="sr-only">Close the search filters</span>
            </button>
            <div className="filters-ui">
                {!hideFacets && (
                    <div className="filters-ui--filter">
                        <button
                            className="filters-ui_button"
                            onClick={onFiltersOpenButtonClick}
                            type="button"
                        >
                            Filter
                        </button>
                    </div>
                )}
                {!hideSearchBar && (
                    <div className="filters-ui--sort">
                        <button
                            className="filters-ui_button"
                            onClick={onSortOpenButtonClick}
                            type="button"
                        >
                            Sort
                        </button>
                    </div>
                )}
                {/* Filter drawer */}
                <div
                    className={`side-drawer--filter ${
                        filtersIsOpen ? 'open' : ''
                    }`}
                >
                    <div className="drawer-header">
                        <div className="drawer-heading">
                            <h3 className="drawer-header_title">Filter</h3>
                            <button
                                className="drawer-close"
                                onClick={onCloseButtonClick}
                                type="button"
                            >
                                <svg className="svg-icon">
                                    <use xlinkHref="#rse-close" />
                                    <title>close</title>
                                </svg>
                            </button>
                        </div>

                        {Object.entries(searchFacetSelections).length !== 0 ? (
                            <div className="drawer_active-filters">
                                <ClearFacetsButton />
                            </div>
                        ) : null}
                    </div>
                    <div className="drawer_content-scrollable">
                        <div className="drawer_filters">{children}</div>
                        <button
                            className="drawer_filter-all-button"
                            onClick={onCloseButtonClick}
                            type="button"
                        >
                            View resources
                            <svg className="svg-icon">
                                <use
                                    xlinkHref="#rse-chevron-right-16"
                                    fill="none"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
                {/* end filter drawer */}
                {/* Sort drawer */}
                <div
                    className={`side-drawer--sort ${sortIsOpen ? 'open' : ''}`}
                >
                    <div className="drawer-header">
                        <div className="drawer-heading">
                            <h3 className="drawer-header_title">Sort by</h3>
                            <button
                                className="drawer-close"
                                onClick={onCloseButtonClick}
                                type="button"
                            >
                                <svg className="svg-icon">
                                    <use xlinkHref="#rse-close" />
                                    <title>close</title>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div className="sorting-options">
                        {sortSelectOptions.map((option) => {
                            const optionIsSelected =
                                option.value === searchSortingValue;

                            let additionalClasses = '';

                            if (optionIsSelected) {
                                additionalClasses = 'is-selected';
                            }

                            return (
                                <div
                                    className="sorting__group"
                                    key={`sort-mobile-${option.value}`}
                                >
                                    <button
                                        aria-selected={optionIsSelected}
                                        className={`sorting-option_button ${additionalClasses}`}
                                        data-option-value={option.value}
                                        id={option.elementId}
                                        onClick={onSelectSortOptionClick}
                                        role="option"
                                        type="button"
                                    >
                                        {option.label}
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </div>
                {/* end sort drawer */}
            </div>
        </div>
    );
}
